import type { Event } from '@vlabs/api/luna-api/model';

import type { MapMarker } from './types';

export function getMarker(
  event?: Pick<Event, 'event_id' | 'location'>,
): MapMarker | null {
  if (!event?.event_id || !event.location?.geo_position) {
    return null;
  }

  return {
    id: event.event_id,
    position: [
      event.location.geo_position.latitude,
      event.location.geo_position.longitude,
    ],
  };
}
